export const defaultUserId = "d1f97640-139d-4c5b-b94f-d66aec200834";

export const maxArtists = 3;
export const lineupSize = 8;
export const lineupCount = 5;
export const weekLength = 7;
export const weekCount = 4;
export const startingDay = 1;
export const startingFreeTrades = 2;
export const maxFreeTrades = 5;
export const extraFreeTradeIncrement = 1;
export const startingPlayerMoney = 100;

export const maxGenres = 3;

/** Divide a week's total points by this constant to get the cost for next week */
export const weekPointCostFactor = 4.6;
export const boostPointMultiplier = 2;
